import { io } from "socket.io-client";

/**
 * Creates a disconnected socket so the caller can attach all listeners before
 * opening the connection.
 */
export const createSocket = (url, token) => io(url, {
  autoConnect: false,
  auth: { token },
});
